/**
 *拖动改变窗体大小
 * Bai.Zhiming
 * 2019-8-8
 */
angular.module('imResizerModule', []).directive('imResizer', [
    function() {
        return {
            restrict: 'A',
            scope: false,
            replace: true,
            transclude: true,
            templateUrl: './IM/directive/resizer/resizer_tpl.html',
            link(scope, $element, $attrs) {
                initStatus();

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    let status = {};
                    angular.extend(scope.status, status);
                    initMinWidthHeight();
                    initParentPosition();
                    getBoundingClientRect();
                    initLeftTop();
                    initTop();
                    initRightTop();
                    initRight();
                    initRightBottom();
                    initBottom();
                    initLeftBottom();
                    initLeft();
                }

                /**
                 * [emitInfo description] 向外发送窗体信息
                 * @return {[type]} [description]
                 */
                function emitInfo() {
                    if (angular.isFunction(scope.resizerInfo)) {
                        getBoundingClientRect();
                        scope.resizerInfo(scope.status.windowBoundingClientRect);
                    }
                }

                /**
                 * [initMinWidthHeight description] 初始化宽高最小值
                 * @return {[type]} [description]
                 */
                function initMinWidthHeight() {
                    let resizerMinWidth = $attrs['resizerMinWidth'];
                    let resizerMinHeight = $attrs['resizerMinHeight'];
                    scope.status.resizerMinWidth = isNaN(resizerMinWidth) ? 0 : Number(resizerMinWidth);
                    scope.status.resizerMinHeight = isNaN(resizerMinHeight) ? 0 : Number(resizerMinHeight);
                }

                /**
                 * [getBoundingClientRect description] 获取窗体盒子数据
                 * @return {[type]} [description]
                 */
                function getBoundingClientRect() {
                    scope.status.windowBoundingClientRect = $element[0].getBoundingClientRect();
                }

                /**
                 * [initLeftTop description] 初始化左上拖动
                 * @return {[type]} [description]
                 */
                function initLeftTop() {
                    let $operationDom = $element.find('.resizer_left_top').eq(0),
                        leftDistance,
                        topDistance,
                        startPageX,
                        startPageY,
                        endPageX,
                        endPageY,
                        isSelf;
                    $operationDom.bind('mousedown', (e) => {
                        isSelf = true;
                        startPageX = e.pageX;
                        startPageY = e.pageY;
                        $('body').bind('mousemove', leftTopMousemove);
                    });
                    $('body').bind('mouseup', leftTopMouseUp);

                    function leftTopMouseUp(e) {
                        $('body').unbind('mousemove', leftTopMousemove);
                        if (!isSelf) {
                            return;
                        }
                        emitInfo();
                        isSelf = false;
                    }

                    /**
                     * [leftTopMousemove description] 左上鼠标移动
                     * @return {[type]} [description]
                     */
                    function leftTopMousemove(e) {
                        getBoundingClientRect();
                        endPageX = e.pageX;
                        endPageY = e.pageY;
                        leftDistance = endPageX - startPageX;
                        topDistance = endPageY - startPageY;
                        startPageX = endPageX;
                        startPageY = endPageY;
                        let newCss = {};
                        let newWidth = scope.status.windowBoundingClientRect.width - leftDistance;
                        let newHeight = scope.status.windowBoundingClientRect.height - topDistance;
                        if (newWidth >= scope.status.resizerMinWidth) {
                            angular.extend(newCss, {
                                width: newWidth,
                                left: scope.status.windowBoundingClientRect.left + leftDistance,
                            });
                        }
                        if (newHeight >= scope.status.resizerMinHeight) {
                            angular.extend(newCss, {
                                height: newHeight,
                                top: scope.status.windowBoundingClientRect.top + topDistance,
                            });
                        }
                        $element.css(newCss);
                    }
                    scope.$on('$destroy', () => {
                        $('body').unbind('mouseup', leftTopMouseUp);
                    });
                }

                /**
                 * [initLeftTop description] 初始化顶部拖动
                 * @return {[type]} [description]
                 */
                function initTop() {
                    let $operationDom = $element.find('.resizer_top').eq(0),
                        topDistance,
                        startPageY,
                        endPageY,
                        isSelf;
                    $operationDom.bind('mousedown', (e) => {
                        isSelf = true;
                        startPageY = e.pageY;
                        $('body').bind('mousemove', topMousemove);
                    });
                    $('body').bind('mouseup', topMouseUp);

                    function topMouseUp(e) {
                        $('body').unbind('mousemove', topMousemove);
                        if (!isSelf) {
                            return;
                        }
                        emitInfo();
                        isSelf = false;
                    }

                    /**
                     * [leftTopMousemove description] 顶部鼠标移动
                     * @return {[type]} [description]
                     */
                    function topMousemove(e) {
                        getBoundingClientRect();
                        endPageY = e.pageY;
                        topDistance = endPageY - startPageY;
                        startPageY = endPageY;
                        let newCss = {};
                        let newHeight = scope.status.windowBoundingClientRect.height - topDistance;
                        if (newHeight >= scope.status.resizerMinHeight) {
                            angular.extend(newCss, {
                                height: newHeight,
                                top: scope.status.windowBoundingClientRect.top + topDistance,
                            });
                        }
                        $element.css(newCss);
                    }
                    scope.$on('$destroy', () => {
                        $('body').unbind('mouseup', topMousemove);
                    });
                }

                /**
                 * [initRightTop description] 初始化右上拖动
                 * @return {[type]} [description]
                 */
                function initRightTop() {
                    let $operationDom = $element.find('.resizer_right_top').eq(0),
                        leftDistance,
                        topDistance,
                        startPageX,
                        startPageY,
                        endPageX,
                        endPageY,
                        isSelf;
                    $operationDom.bind('mousedown', (e) => {
                        isSelf = true;
                        startPageX = e.pageX;
                        startPageY = e.pageY;
                        $('body').bind('mousemove', rightTopMousemove);
                    });
                    $('body').bind('mouseup', rightTopMouseUp);

                    function rightTopMouseUp(e) {
                        $('body').unbind('mousemove', rightTopMousemove);
                        if (!isSelf) {
                            return;
                        }
                        emitInfo();
                        isSelf = false;
                    }

                    /**
                     * [rightTopMousemove description] 右上鼠标移动
                     * @return {[type]} [description]
                     */
                    function rightTopMousemove(e) {
                        getBoundingClientRect();
                        endPageX = e.pageX;
                        endPageY = e.pageY;
                        leftDistance = endPageX - startPageX;
                        topDistance = endPageY - startPageY;
                        startPageX = endPageX;
                        startPageY = endPageY;
                        let newCss = {};
                        let newWidth = scope.status.windowBoundingClientRect.width + leftDistance;
                        let newHeight = scope.status.windowBoundingClientRect.height - topDistance;
                        if (newWidth >= scope.status.resizerMinWidth) {
                            angular.extend(newCss, {
                                width: newWidth,
                            });
                        }
                        if (newHeight >= scope.status.resizerMinHeight) {
                            angular.extend(newCss, {
                                height: newHeight,
                                top: scope.status.windowBoundingClientRect.top + topDistance,
                            });
                        }
                        $element.css(newCss);
                    }
                    scope.$on('$destroy', () => {
                        $('body').unbind('mouseup', rightTopMouseUp);
                    });
                }

                /**
                 * [initRight description] 初始化右拖动
                 * @return {[type]} [description]
                 */
                function initRight() {
                    let $operationDom = $element.find('.resizer_right').eq(0),
                        leftDistance,
                        startPageX,
                        endPageX,
                        isSelf;
                    $operationDom.bind('mousedown', (e) => {
                        isSelf = true;
                        startPageX = e.pageX;
                        $('body').bind('mousemove', rightMousemove);
                    });
                    $('body').bind('mouseup', rightMouseUp);

                    function rightMouseUp(e) {
                        $('body').unbind('mousemove', rightMousemove);
                        if (!isSelf) {
                            return;
                        }
                        emitInfo();
                        isSelf = false;
                    }

                    /**
                     * [leftTopMousemove description] 右鼠标移动
                     * @return {[type]} [description]
                     */
                    function rightMousemove(e) {
                        getBoundingClientRect();
                        endPageX = e.pageX;
                        leftDistance = endPageX - startPageX;
                        startPageX = endPageX;
                        let newCss = {};
                        let newWidth = scope.status.windowBoundingClientRect.width + leftDistance;
                        if (newWidth >= scope.status.resizerMinWidth) {
                            angular.extend(newCss, {
                                width: newWidth,
                            });
                        }
                        $element.css(newCss);
                    }
                    scope.$on('$destroy', () => {
                        $('body').unbind('mouseup', rightMouseUp);
                    });
                }

                /**
                 * [initRightBottom description] 初始化右下拖动
                 * @return {[type]} [description]
                 */
                function initRightBottom() {
                    let $operationDom = $element.find('.resizer_right_bottom').eq(0),
                        leftDistance,
                        topDistance,
                        startPageX,
                        startPageY,
                        endPageX,
                        endPageY,
                        isSelf;
                    $operationDom.bind('mousedown', (e) => {
                        isSelf = true;
                        startPageX = e.pageX;
                        startPageY = e.pageY;
                        $('body').bind('mousemove', rightBottomMousemove);
                    });
                    $('body').bind('mouseup', rightBottomMouseUp);

                    function rightBottomMouseUp(e) {
                        $('body').unbind('mousemove', rightBottomMousemove);
                        if (!isSelf) {
                            return;
                        }
                        emitInfo();
                        isSelf = false;
                    }

                    /**
                     * [rightBottomMousemove description] 右下鼠标移动
                     * @return {[type]} [description]
                     */
                    function rightBottomMousemove(e) {
                        getBoundingClientRect();
                        endPageX = e.pageX;
                        endPageY = e.pageY;
                        leftDistance = endPageX - startPageX;
                        topDistance = endPageY - startPageY;
                        startPageX = endPageX;
                        startPageY = endPageY;
                        let newCss = {};
                        let newWidth = scope.status.windowBoundingClientRect.width + leftDistance;
                        let newHeight = scope.status.windowBoundingClientRect.height + topDistance;
                        if (newWidth >= scope.status.resizerMinWidth) {
                            angular.extend(newCss, {
                                width: newWidth,
                            });
                        }
                        if (newHeight >= scope.status.resizerMinHeight) {
                            angular.extend(newCss, {
                                height: newHeight,
                            });
                        }
                        $element.css(newCss);
                    }
                    scope.$on('$destroy', () => {
                        $('body').unbind('mouseup', rightBottomMouseUp);
                    });
                }

                /**
                 * [initBottom description] 初始化底部拖动
                 * @return {[type]} [description]
                 */
                function initBottom() {
                    let $operationDom = $element.find('.resizer_bottom').eq(0),
                        topDistance,
                        startPageY,
                        endPageY,
                        isSelf;
                    $operationDom.bind('mousedown', (e) => {
                        isSelf = true;
                        startPageY = e.pageY;
                        $('body').bind('mousemove', bottomMousemove);
                    });
                    $('body').bind('mouseup', bottomMouseUp);

                    function bottomMouseUp(e) {
                        $('body').unbind('mousemove', bottomMousemove);
                        if (!isSelf) {
                            return;
                        }
                        emitInfo();
                        isSelf = false;
                    }

                    /**
                     * [bottomMousemove description] 底部鼠标移动
                     * @return {[type]} [description]
                     */
                    function bottomMousemove(e) {
                        getBoundingClientRect();
                        endPageY = e.pageY;
                        topDistance = endPageY - startPageY;
                        startPageY = endPageY;
                        let newCss = {};
                        let newHeight = scope.status.windowBoundingClientRect.height + topDistance;
                        if (newHeight >= scope.status.resizerMinHeight) {
                            angular.extend(newCss, {
                                height: newHeight,
                            });
                        }
                        $element.css(newCss);
                    }
                    scope.$on('$destroy', () => {
                        $('body').unbind('mouseup', bottomMousemove);
                    });
                }

                /**
                 * [initLeftBottom description] 初始化左下拖动
                 * @return {[type]} [description]
                 */
                function initLeftBottom() {
                    let $operationDom = $element.find('.resizer_left_bottom').eq(0),
                        leftDistance,
                        topDistance,
                        startPageX,
                        startPageY,
                        endPageX,
                        endPageY,
                        isSelf;
                    $operationDom.bind('mousedown', (e) => {
                        isSelf = true;
                        startPageX = e.pageX;
                        startPageY = e.pageY;
                        $('body').bind('mousemove', leftBottomMousemove);
                    });
                    $('body').bind('mouseup', leftBottomMouseUp);

                    function leftBottomMouseUp(e) {
                        $('body').unbind('mousemove', leftBottomMousemove);
                        if (!isSelf) {
                            return;
                        }
                        emitInfo();
                        isSelf = false;
                    }

                    /**
                     * [leftTopMousemove description] 左下鼠标移动
                     * @return {[type]} [description]
                     */
                    function leftBottomMousemove(e) {
                        getBoundingClientRect();
                        endPageX = e.pageX;
                        endPageY = e.pageY;
                        leftDistance = endPageX - startPageX;
                        topDistance = endPageY - startPageY;
                        startPageX = endPageX;
                        startPageY = endPageY;
                        let newCss = {};
                        let newWidth = scope.status.windowBoundingClientRect.width - leftDistance;
                        let newHeight = scope.status.windowBoundingClientRect.height + topDistance;
                        if (newWidth >= scope.status.resizerMinWidth) {
                            angular.extend(newCss, {
                                width: newWidth,
                                left: scope.status.windowBoundingClientRect.left + leftDistance,
                            });
                        }
                        if (newHeight >= scope.status.resizerMinHeight) {
                            angular.extend(newCss, {
                                height: newHeight,
                            });
                        }
                        $element.css(newCss);
                    }
                    scope.$on('$destroy', () => {
                        $('body').unbind('mouseup', leftBottomMouseUp);
                    });
                }

                /**
                 * [initLeft description] 初始化左拖动
                 * @return {[type]} [description]
                 */
                function initLeft() {
                    let $operationDom = $element.find('.resizer_left').eq(0),
                        leftDistance,
                        startPageX,
                        endPageX,
                        isSelf;
                    $operationDom.bind('mousedown', (e) => {
                        isSelf = true;
                        startPageX = e.pageX;
                        $('body').bind('mousemove', leftMousemove);
                    });
                    $('body').bind('mouseup', leftMouseUp);

                    function leftMouseUp(e) {
                        $('body').unbind('mousemove', leftMousemove);
                        if (!isSelf) {
                            return;
                        }
                        emitInfo();
                        isSelf = false;
                    }

                    /**
                     * [leftMousemove description] 左鼠标移动
                     * @return {[type]} [description]
                     */
                    function leftMousemove(e) {
                        getBoundingClientRect();
                        endPageX = e.pageX;
                        leftDistance = endPageX - startPageX;
                        startPageX = endPageX;
                        let newCss = {};
                        let newWidth = scope.status.windowBoundingClientRect.width - leftDistance;
                        if (newWidth >= scope.status.resizerMinWidth) {
                            angular.extend(newCss, {
                                width: newWidth,
                                left: scope.status.windowBoundingClientRect.left + leftDistance,
                            });
                        }
                        $element.css(newCss);
                    }
                    scope.$on('$destroy', () => {
                        $('body').unbind('mouseup', leftMouseUp);
                    });
                }

                /**
                 * [initParentPosition description] 初始化父节点的position
                 * @return {[type]} [description]
                 */
                function initParentPosition() {
                    let position = $element.css('position');
                    if (position == 'relative' || position == 'absolute') {
                        return;
                    }
                    $element.css('position', 'relative');
                }
            },
        };
    },
]);
